package ru.villawonka.app.common.extensions

import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.runtime.*

fun LazyListState.scrollPosition(): Int {
    val itemLengthInPx = layoutInfo.visibleItemsInfo.firstOrNull()?.size ?: 0
    return (firstVisibleItemIndex * itemLengthInPx) + firstVisibleItemScrollOffset
}

@Composable
fun LazyListState.isScrollingUp(): Boolean {
    var previousIndex by remember(this) { mutableStateOf(firstVisibleItemIndex) }
    var previousScrollOffset by remember(this) { mutableStateOf(firstVisibleItemScrollOffset) }
    return remember(this) {
        derivedStateOf {
            if (previousIndex != firstVisibleItemIndex) {
                previousIndex > firstVisibleItemIndex
            } else {
                previousScrollOffset >= firstVisibleItemScrollOffset
            }.also {
                previousIndex = firstVisibleItemIndex
                previousScrollOffset = firstVisibleItemScrollOffset
            }
        }
    }.value
}